import { getIsMeta } from '@mfs/common/urlParams'

/** Exclude all meta ref IDs (deep-link from Kayak, Google, etc)  */
function checkRefId(paramsObj) {
  return !getIsMeta(paramsObj)
}

const getSearchParams = ({ pclnBootstrapData } = {}) => pclnBootstrapData?.searchRequest?.params || {}

const getIsLocationEligible = ({ hasUsOnlySlice, featureToggles }) =>
  hasUsOnlySlice ? Boolean(featureToggles?.flights?.enableDomesticLapInfants) : true

const isPackageSearchPath = (pclnBootstrapData = {}) =>
  Boolean(pclnBootstrapData.fromPackages || pclnBootstrapData.isPackageListings)

/**
 * Standalone: infants + non-meta + domestic LD toggle.
 * Packages CONTROL: off (legacy !fromPackages).
 * Packages VARIANT: infants + non-meta, international only (`!hasUsOnlySlice`).
 * SSR-safe listings read: `pclnBootstrapData.seti` (same as airSearchRequest).
 */
const getIsInfantPricingEligible = ({ pclnBootstrapData } = {}) => {
  if (!pclnBootstrapData) {
    return false
  }

  const searchParams = getSearchParams({ pclnBootstrapData })
  const isPackagePath = isPackageSearchPath(pclnBootstrapData)
  const isPkgLapInfantVariant = Boolean(
    pclnBootstrapData.seti?.PKG_ENABLE_FLY_LAP_INFANT_TICKETING?.isVariant
  )
  const isInternational = !pclnBootstrapData.hasUsOnlySlice

  return (
    Number(searchParams['num-infants'] || 0) > 0 &&
    checkRefId(searchParams) &&
    (isPackagePath ? isPkgLapInfantVariant && isInternational : getIsLocationEligible(pclnBootstrapData))
  )
}

const getIsChildPricingEligible = ({ pclnBootstrapData } = {}) => {
  if (!pclnBootstrapData) {
    return false
  }

  const searchParams = getSearchParams({ pclnBootstrapData })
  const { fromPackages } = pclnBootstrapData
  return Number(searchParams['num-children'] || 0) > 0 && checkRefId(searchParams) && !fromPackages
}

export { getIsInfantPricingEligible, getIsChildPricingEligible }
